// extracted by mini-css-extract-plugin
export default {"Splitter_Dash":"Splitter_Splitter_Dash__Y2qvv","Grid_ColumnSplitter":"Splitter_Grid_ColumnSplitter__vSl6v","Grid_RowSplitter":"Splitter_Grid_RowSplitter__6957w"};